const env = process.env;

export const Config = {
  FRONTEND_URL: env.REACT_APP_FRONTEND_URL,
  BACKEND_DOMAIN: env.REACT_APP_BACKEND_DOMAIN || env.REACT_APP_API_URL?.replace('/api/', ''),
  API_URL: env.REACT_APP_API_URL,
};

